import {memo} from 'react';

import {attachModal} from '~/shared/components/ReduxModal';

import DeleteAccountWarning from './DeleteAccountWarning';

export const RemoveAccountModal = ({closeModal}) => {
  return <DeleteAccountWarning onCancel={closeModal} onContinue={closeModal} />;
};

attachModal('remove_account_modal', memo(RemoveAccountModal));
